/* tslint:disable */
/* eslint-disable */
/**
 * My Title
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ReassignInspectionRequest
 */
export interface ReassignInspectionRequest {
    /**
     * 
     * @type {number}
     * @memberof ReassignInspectionRequest
     */
    targetAssetId?: number;
}

/**
 * Check if a given object implements the ReassignInspectionRequest interface.
 */
export function instanceOfReassignInspectionRequest(value: object): value is ReassignInspectionRequest {
    return true;
}

export function ReassignInspectionRequestFromJSON(json: any): ReassignInspectionRequest {
    return ReassignInspectionRequestFromJSONTyped(json, false);
}

export function ReassignInspectionRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReassignInspectionRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'targetAssetId': json['targetAssetId'] == null ? undefined : json['targetAssetId'],
    };
}

export function ReassignInspectionRequestToJSON(json: any): ReassignInspectionRequest {
    return ReassignInspectionRequestToJSONTyped(json, false);
}

export function ReassignInspectionRequestToJSONTyped(value?: ReassignInspectionRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'targetAssetId': value['targetAssetId'],
    };
}

